var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-refresh","titulo":"REABERTURAS DE ENTREGAS","subTitulo":"SGF GERENTE","qtd":_vm.qtd,"mostrarQtd":_vm.$temAcessoView('CRED-GER-ENTR-02') ? true : false,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gerentes_SolicitacoesReaberturas' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }